import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Suspense } from 'react';
import { AuthProvider } from './auth/AuthContext';
import { ProtectedRoute } from './auth/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';
import FloatingLanguageSwitcher from './components/FloatingLanguageSwitcher';
import QueuePage from './pages/QueuePage';
import LoginPage from './pages/admin/LoginPage';
import SignupPage from './pages/admin/SignupPage';
import SettingsPage from './pages/admin/SettingsPage';
import AcceptInvitePage from './pages/admin/AcceptInvitePage';
import ForgotPasswordPage from './pages/admin/ForgotPasswordPage';
import ResetPasswordPage from './pages/admin/ResetPasswordPage';
import StaffQueuePage from './pages/admin/QueuePage';
import LandingPage from './pages/LandingPage';
import VerifyEmailPage from './pages/admin/VerifyEmailPage';
import SetupWizardPage from './pages/admin/SetupWizardPage';
import SystemHealthPage from './pages/admin/monitor/SystemHealthPage';
import BusinessPage from './pages/admin/monitor/BusinessPage';
import TenantsPage from './pages/admin/monitor/TenantsPage';
import SessionsPage from './pages/admin/monitor/SessionsPage';
import AccountManagementPage from './pages/admin/monitor/AccountManagementPage';
import AnalyticsPage from './pages/admin/monitor/AnalyticsPage';
import QueueInspectorPage from './pages/admin/monitor/QueueInspectorPage';
import DeadLetterPage from './pages/admin/monitor/DeadLetterPage';
import BizAnalyticsPage from './pages/admin/AnalyticsPage';
import CompleteSignupPage from './pages/admin/CompleteSignupPage';
import WelcomePage from './pages/admin/WelcomePage';
import Sidebar from './components/admin/Sidebar';
import KioskPage from './pages/KioskPage';
import DisplayPage from './pages/DisplayPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import ImprintPage from './pages/ImprintPage';
import DpaPage from './pages/DpaPage';
import NotFoundPage from './pages/NotFoundPage';

export default function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Suspense fallback={null}>
            <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/q/:shopId" element={<QueuePage />} />
            <Route path="/kiosk/:shopId" element={<KioskPage />} />
            <Route path="/display/:shopId" element={<DisplayPage />} />
            <Route path="/admin/login" element={<LoginPage />} />
            <Route path="/admin/signup" element={<SignupPage />} />
            <Route path="/admin/complete-signup" element={<CompleteSignupPage />} />
            <Route path="/admin/accept-invite" element={<AcceptInvitePage />} />
            <Route path="/admin/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/admin/reset-password" element={<ResetPasswordPage />} />
            <Route path="/admin/verify-email" element={<VerifyEmailPage />} />
            <Route path="/admin/monitor" element={<Navigate to="/admin/monitor/system" replace />} />
            <Route path="/admin/monitor/system" element={
              <ProtectedRoute allowedRoles={['ADMIN']}><Sidebar><SystemHealthPage /></Sidebar></ProtectedRoute>
            } />
            <Route path="/admin/monitor/business" element={
              <ProtectedRoute allowedRoles={['ADMIN']}><Sidebar><BusinessPage /></Sidebar></ProtectedRoute>
            } />
            <Route path="/admin/monitor/tenants" element={
              <ProtectedRoute allowedRoles={['ADMIN']}><Sidebar><TenantsPage /></Sidebar></ProtectedRoute>
            } />
            <Route path="/admin/monitor/sessions" element={
              <ProtectedRoute allowedRoles={['ADMIN']}><Sidebar><SessionsPage /></Sidebar></ProtectedRoute>
            } />
            <Route path="/admin/monitor/account" element={
              <ProtectedRoute allowedRoles={['ADMIN']}><Sidebar><AccountManagementPage /></Sidebar></ProtectedRoute>
            } />
            <Route path="/admin/monitor/analytics" element={
              <ProtectedRoute allowedRoles={['ADMIN']}><Sidebar><AnalyticsPage /></Sidebar></ProtectedRoute>
            } />
            <Route path="/admin/monitor/queues" element={
              <ProtectedRoute allowedRoles={['ADMIN']}><Sidebar><QueueInspectorPage /></Sidebar></ProtectedRoute>
            } />
            <Route path="/admin/monitor/dead-letter" element={
              <ProtectedRoute allowedRoles={['ADMIN']}><Sidebar><DeadLetterPage /></Sidebar></ProtectedRoute>
            } />
            <Route path="/admin/analytics" element={
              <ProtectedRoute deniedRoles={['ADMIN']}>
                <Sidebar><BizAnalyticsPage /></Sidebar>
              </ProtectedRoute>
            } />
            <Route path="/admin/welcome" element={
              <ProtectedRoute deniedRoles={['ADMIN']}>
                <WelcomePage />
              </ProtectedRoute>
            } />
            <Route path="/admin/setup" element={
              <ProtectedRoute deniedRoles={['ADMIN']}>
                <SetupWizardPage />
              </ProtectedRoute>
            } />
            <Route path="/admin/queue" element={
              <ProtectedRoute deniedRoles={['ADMIN']}>
                <Sidebar><StaffQueuePage /></Sidebar>
              </ProtectedRoute>
            } />
            <Route path="/admin/settings" element={
              <ProtectedRoute deniedRoles={['ADMIN']}>
                <Sidebar><SettingsPage /></Sidebar>
              </ProtectedRoute>
            } />
            <Route path="/admin/dashboard" element={<Navigate to="/admin/queue" replace />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/imprint" element={<ImprintPage />} />
            <Route path="/legal/dpa" element={<DpaPage />} />
            <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
          <FloatingLanguageSwitcher />
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}
